/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Checkout_ErrorInputs */

const en_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to create checkout session. Please try again.`)
};

const de_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Erstellen der Checkout-Sitzung. Bitte versuch es erneut.`)
};

const fr_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Échec de la création de la session de paiement. Réessaie.`)
};

const es_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al crear la sesión de pago. Por favor, inténtelo de nuevo.`)
};

const it_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile creare la sessione di checkout. Riprova.`)
};

const nl_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mislukt om een checkout-sessie te maken. Probeer het opnieuw.`)
};

const pl_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się utworzyć sesji płatności. Spróbuj ponownie.`)
};

const fi_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maksutapahtuman luominen epäonnistui. Yritä uudelleen.`)
};

const da_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kunne ikke oprette checkout session. Prøv igen.`)
};

const sv_pricing_checkout_error = /** @type {(inputs: Pricing_Checkout_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Misslyckades att skapa betalningssession. Försök igen.`)
};

/**
* | output |
* | --- |
* | "Failed to create checkout session. Please try again." |
*
* @param {Pricing_Checkout_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_checkout_error = /** @type {((inputs?: Pricing_Checkout_ErrorInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Checkout_ErrorInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_checkout_error(inputs)
	if (locale === "fr") return fr_pricing_checkout_error(inputs)
	if (locale === "es") return es_pricing_checkout_error(inputs)
	if (locale === "it") return it_pricing_checkout_error(inputs)
	if (locale === "nl") return nl_pricing_checkout_error(inputs)
	if (locale === "pl") return pl_pricing_checkout_error(inputs)
	if (locale === "fi") return fi_pricing_checkout_error(inputs)
	if (locale === "da") return da_pricing_checkout_error(inputs)
	if (locale === "sv") return sv_pricing_checkout_error(inputs)
	return en_pricing_checkout_error(inputs)
});